module.exports = __webpack_public_path__ + "img/dp03.078d5658.png";